import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Divider, Heading } from "@nn-design-system/react-component-library";
import CustomRadioGroup from "../../../../../Components/CustomInputs/CustomRadioGroup";
import GridContainer from "../../../../../Components/ReportFormTemplate/GridContainer";
import WholeLineContainer from "../../../../../Components/ReportFormTemplate/WholeLineContainer";
import { StoreType } from "../../../../../redux/store/store";
import { updateFifthStepFields } from "../../../../../redux/reducers/claimReducer";
import { handleShowErrorMessage } from "../../../../../redux/reducers/claimFieldErrorsReducer";

const legalRepresentativeTooltip =
   "V případě pojistného plnění v celkové hodnotě 25 000 Kč a více zákonnému zástupci dítěte pojišťovna může vyžadovat doložení dokladu, který jej opravňuje k zastupování (rodný list dítěte, občanský průkaz se zápisem dítěte, či rozhodnutí soudu).";
const otherReporterTooltip =
   "Jiným oznamovatelem je zplnomocněný zástupce pojištěného, který jedná na základě platné plné moci. Plnou moc prosím přiložte v části „Dokumenty“.";

const ReporterRoleSection: React.FC = () => {
   const dispatch = useDispatch();
    const { isChild, reporterRole } = useSelector(
       (state: StoreType) => state.claimState.reportModel
    );
    const claimFieldErrorsMessages = useSelector(
       (state: StoreType) => state.claimFieldErrorsState
    );
   const isDeathClaim = useSelector((state: StoreType) =>
      state.claimState.selectedTypeOfClaims.some((claim) => claim === "death")
   );

   if (isDeathClaim) {
      return null;
   }

   const selfRole = isChild ? 1 : 0;

   return (
      <GridContainer>
         <WholeLineContainer>
            <>
               <Heading variant="Medium" hasMargin={false} mb=".5rem" mt="1rem">
                  Role oznamovatele
               </Heading>
               <Divider variant="Brand" />
            </>
         </WholeLineContainer>
         <WholeLineContainer>
            <CustomRadioGroup
               heading="Oznamovatel a příjemce plnění"
               firstLabel={isChild ? "Zákonný zástupce nezletilé osoby" : "Pojištěný"}
               secondLabel="Jiná osoba"
               firstOptionPopoverText={isChild ? legalRepresentativeTooltip : undefined}
               secondOptionPopoverText={otherReporterTooltip}
               value={reporterRole === 2 ? false : reporterRole === selfRole ? true : null}
               updateFunc={(value: string) =>
                  dispatch(
                     updateFifthStepFields({
                        field: "reporterRole",
                        value: value === "true" ? selfRole : 2,
                     })
                  )
               }
               validationText={handleShowErrorMessage("ReporterRole", claimFieldErrorsMessages)}
            />
         </WholeLineContainer>
      </GridContainer>
   );
};

export default ReporterRoleSection;
